import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

import { Router } from '@angular/router';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  ver:string="";
  nota: string="";
  menuVisible:boolean = true;
  errMsg: string = "";
  theme:string = "";
  tiempoMsg: number;
  general:any;
  folios: any=[];
  bases: any;
  gestora:any;
  origen:any;
  contrato:string="";  //CEP: 20914041415 B0A5#1EC,   PRO: 60914017008 CCB4#3A5
  idSuc:string = "";
  hoy:Date = new Date();
  ayer: Date = new Date();
  fechaAyer: string = "";
  fechaCto: string = "";
  existe:any;

  posIniConceptos:number;
  imgLogoBase64Fact:any;
  formatoFactura:any=[];
  formStyle:any[];
  formFacturaStyle:any[];
  elemImpFactura:any[];
  elemStyle:any[]=[]  
  elemFacturaStyle:any[]=[]  
  auxLogo:any;
  auxLogoFact:any;
  auxQR:any;
  qrcode="";
  regimen:any[]=[];
  tfact:any[]=[];
  usos:any[]=[];
  moneda:any[]=[];
  formaPago: any[]=[];
  metodoPago: any[]=[];

  formato:any[];
  elemImp:any[];
  fueReestructura: boolean = false;
  esReestruct: boolean = false;

  constructor(private dataService: DataService, private router:Router) { }

  ngOnInit() {
    this.contrato = this.dataService.tmpCto.toString();
    this.idSuc = this.dataService.tmpCve.toString();
    //console.log(this.contrato);
    //console.log(this.idSuc);
    this.tiempoMsg = this.dataService.sTerr;
    this.ver = this.dataService.infoVer();
    this.ayer.setDate(this.hoy.getDate() - 1);
    var dd = String(this.ayer.getDate()).padStart(2, '0');
    var mm = String(this.ayer.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = this.ayer.getFullYear();
    this.fechaAyer = mm + '/' + dd + '/' + yyyy;
    this.dataService.getGestoraGes(this.contrato, this.idSuc).subscribe(
                        row => { this.gestora = <any>row; },
                        error => this.errMsg = <any>error,
                        () => this.fngestoraCargada()
                      );
    this.dataService.getFormatoImp("3 OR c.idModulo = 49","1,2,3").subscribe(
                        rows => {   
                                this.formato = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnFormatoImpCargado());   
    this.dataService.getFormatoFacturaImp('1,2').subscribe(
                              rows => {   
                                      this.formatoFactura = <any>rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnFormatoFacturaCargado());                                                              
    this.dataService.getSatRegimen("TODOS").subscribe(
                                rows => {   
                                        this.regimen = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnRegimenCargado());   
    this.dataService.getSatTipoFactura().subscribe(
                                rows => {   
                                        this.tfact = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnTipoFacturaCargada());   
    this.dataService.getSatUso().subscribe(
                                rows => {   
                                        this.usos = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnSatUsoCargado());   
    this.dataService.getSatMoneda().subscribe(
                                  rows => {   
                                          this.moneda = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnSatMonedaCargada());   
    this.dataService.getSatForma().subscribe(
                                  rows => {   
                                          this.formaPago = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnSatFormaCargada());       
    this.dataService.getSatMetodo().subscribe(
                                  rows => {   
                                          this.metodoPago = <any>rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnSatMetodoCargado()); 

    this.fnFormatoFactura();

  }

  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
        arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), 1).subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  fnFormatoFactura(){
    var idFormato = 7;
    this.dataService.getElemFormatoImp(idFormato, "'IMAGE', 'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW'", 1).subscribe(
                        rows => {   
                                this.elemImpFactura = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnElementosImpresionFacturaCargados(idFormato));              
  }
  
  fnElementosImpresionFacturaCargados(idFormato){
    //console.log(this.elemImpFactura);
  }

  fnRegimenCargado(){
    //console.log(this.regimen);
  }

  fnTipoFacturaCargada(){
    //console.log(this.tfact);
  }

  fnSatUsoCargado(){
    //console.log(this.usos);
  }

  fnSatMonedaCargada(){
    //console.log(this.moneda);
  }

  fnSatFormaCargada(){
    //console.log(this.formaPago);
  }

  fnSatMetodoCargado(){
    //console.log(this.metodoPago);
  }
  
  fnFormatoFacturaCargado(){
    //console.log("Formato Factura: ");
    //console.log(this.formatoFactura);
    var arrIdForms = [];
    for(var i = 0; i < this.formatoFactura.length; i++){
      arrIdForms.push(this.formatoFactura[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formFacturaStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormFacturaStyleCargado())
  }


  fnFormFacturaStyleCargado(){
    //console.log(this.formFacturaStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formFacturaStyle.length; i++){
      arrStyles.push(this.formFacturaStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemFacturaStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formFacturaStyle.length; k++){
        if(arrStyles[i] == this.formFacturaStyle[k].style){
            var auxObj = Object.keys(this.elemFacturaStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemFacturaStyle[arrStyles[i]] = {[this.formFacturaStyle[k].key]:this.formFacturaStyle[k].valor} ;
            else
              this.elemFacturaStyle[arrStyles[i]][this.formFacturaStyle[k].key]   = this.formFacturaStyle[k].valor;
        }
      }
    }
    //console.log(this.elemFacturaStyle);
  }

  fngestoraCargada(){
    //console.log(this.gestora);
    this.nota = "Las facturas pueden tardar 48hrs después de su generación para mostrarse en el portal. ";
    this.nota += "Para la obtención de facturas no mostradas o estados de cuenta de meses anteriores favor de solicitarlos a:  " + this.gestora[0].mail + " ó " + this.gestora[0].tel + ".";
    this.dataService.getGeneralesGes(this.contrato, this.idSuc).subscribe(
                                row => { this.general = <any>row; },
                                error => this.errMsg = <any>error,
                                () => this.fnGeneralesCargados()
                              );
    this.dataService.getFoliosGes(this.contrato, this.gestora[0].rfc).subscribe(
                                row => { this.folios = <any>row; },
                                error => this.errMsg = <any>error,
                                () => this.fnFoliosCargados()
                              );
}
  
fnGeneralesCargados(){
    console.log(this.general);
    if(this.general.length > 0)
      this.fechaCto = this.general[0].fecCto;
}

fnFoliosCargados(){
    //console.log(this.folios);
}


  fnSalir(){
    //console.log("salir");
    this.dataService.tmpCto = -1;
    this.dataService.tmpCve = '';
    this.router.navigate(['login']);
  }

  fnVerMenu(menu){
    menu.toggle();
    if (this.menuVisible)
        this.menuVisible = false;
    else
        this.menuVisible = true;
  }

  fnOcultaMenu(menu){
    menu.close();
  }

  fnKeyDownMenu(ev){
    //console.log("MENU KEYDOWN");
    //console.log(ev.key);    
    ev.preventDefault();
  }

  fnDownloadEdoCta(tipo){
    if(tipo == "ULTIMO"){
      console.log("Crea PDF EdoCta");
      this.fnImprimir(4)
    }
  }

  fnDownloadXML(item){
    this.dataService.downloadFile(item.serie + item.folio , item.xmlPAC);
  }

  fnCreatePDF(factura){
    //console.log(this.gestoras);
    //console.log(this.item);
    //console.log(this.elemImpFactura) 
    //console.log(this.formatoFactura);
    //console.log(factura);
    var idFormato = 7;
    var index = this.formatoFactura.findIndex(x => x.id === idFormato);
    var margins =this.formatoFactura[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formatoFactura[index].lineHeight;
    var text = [];
    var text2 = [];
    var columns = [];
    var canvas = [];
    var images = [];  
    var table = [];
    var styles = this.elemFacturaStyle;
    var auxReg = "";
    var auxFolio = "";    
    var auxTipo = ""
    var auxUso = "";

    //var auxGes =  this.dataService.findItemInObject(this.gestoras, factura.cveGes, "cve");
    var auxGes = this.gestora[0];
    this.qrcode = factura.qrcode;
    setTimeout(() => {
      var aux = <HTMLImageElement>document.getElementById("imgFactLogo");
      //aux.src = "../../../assets/imgs/gemp/" + this.dataService.findItemInObject(this.gestoras, auxGes.id, "id").logo;                              
      aux.src = "../../../assets/imgs/searchCFDGes/" + this.gestora[0].logo;
      this.auxLogoFact = <HTMLImageElement>document.getElementById("imgFactLogo"); 
      setTimeout(() => {
        this.auxQR = <HTMLImageElement>document.getElementById("imgQR"); 
        var auxImgQR = this.auxQR.getElementsByTagName("img")[0];
        //console.log(auxImgQR)  
        this.imgLogoBase64Fact = this.dataService.fnGetBase64Image(this.auxLogoFact, this.auxLogoFact.naturalWidth, this.auxLogoFact.naturalHeight);
        //console.log(this.auxLogoFact)
    
        var auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "REGIMENFISCAL");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "REGIMENFISCAL");
        if(auxaux.length > 0){
          auxReg = this.dataService.findItemInObject(this.regimen, auxaux, "id").valor;
        }
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "TIPODECOMPROBANTE");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "TIPODECOMPROBANTE");
        if(auxaux.length > 0)
          auxTipo = this.dataService.findItemInObject(this.tfact, auxaux, "id").valor;
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "USOCFDI");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "USOCFDI");
        if(auxaux.length > 0)
          auxUso = this.dataService.findItemInObject(this.usos, auxaux, "id").valor;
        auxFolio = factura.UUID;
        var auxCto = factura.cto;
        var auxCte = factura.cte;
        var auxLugarExp = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "LUGAREXPEDICION");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "LUGAREXPEDICION");
          auxLugarExp = auxaux;
        var auxMoneda = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "MONEDA");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "MONEDA");
        if(auxaux.length > 0)
          auxMoneda = this.dataService.findItemInObject(this.moneda, auxaux, "id").valor;
        var auxFormaPago = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "FORMAPAGO");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "FORMAPAGO");
        if(auxaux.length > 0)
          auxFormaPago = this.dataService.findItemInObject(this.formaPago, auxaux, "id").valor;
        var auxMetodoPago = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "METODOPAGO");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "METODOPAGO");
        if(auxaux.length > 0)
          auxMetodoPago = this.dataService.findItemInObject(this.metodoPago, auxaux, "id").valor;
        var auxSelloSAT = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "SELLOSAT");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "SELLOSAT");
        auxSelloSAT = auxaux;
        var auxRFCPAC = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "RFCPROVCERTIF");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "RFCPROVCERTIF");
        auxRFCPAC = auxaux;
        var auxFechaTimbre = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "FECHATIMBRADO");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "FECHATIMBRADO");
        auxFechaTimbre = auxaux;
        var auxCertSAT = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "NOCERTIFICADOSAT");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "NOCERTIFICADOSAT");
        auxCertSAT = auxaux;
        var auxImpuestosTras = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "TOTALIMPUESTOSTRASLADADOS");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "TOTALIMPUESTOSTRASLADADOS");
          if(auxaux == "" || auxaux == "NaN" || auxaux == null || auxaux == "null" )
          auxImpuestosTras = "0";
        else
          auxImpuestosTras = auxaux;
        var auxImpuestosRet = "";
        auxaux = this.fnGetValorComillaSimple(factura.xmlPAC, "TOTALIMPUESTOSRETENIDOS");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(factura.xmlPAC, "TOTALIMPUESTOSRETENIDOS");
        if(auxaux == "" || auxaux == "NaN" || auxaux == null || auxaux == "null" )
          auxImpuestosRet = "0";
        else
          auxImpuestosRet = auxaux;
        this.posIniConceptos = factura.xmlPAC.toUpperCase().indexOf("CFDI:CONCEPTO ");
        var c1 = this.fnGetValorConceptoAmpersand(1, factura.xmlPAC, "CFDI:CONCEPTO");
        var c2 = this.fnGetValorConceptoAmpersand(2, factura.xmlPAC, "CFDI:CONCEPTO");
        var c3 = this.fnGetValorConceptoAmpersand(3, factura.xmlPAC, "CFDI:CONCEPTO");
        var c4 = this.fnGetValorConceptoAmpersand(4, factura.xmlPAC, "CFDI:CONCEPTO");
        var c5 = this.fnGetValorConceptoAmpersand(5, factura.xmlPAC, "CFDI:CONCEPTO");
        var auxQty1 = "";
        var auxProd1 = "";
        var auxUni1 = "";
        var auxConcep1 = "";
        var auxValorUni1 = "";
        var auxImporte1 = "";
        var auxQty2 = "";
        var auxProd2 = "";
        var auxUni2 = "";
        var auxConcep2 = "";
        var auxValorUni2 = "";
        var auxImporte2 = "";
        var auxQty3 = "";
        var auxProd3 = "";
        var auxUni3 = "";
        var auxConcep3 = "";
        var auxValorUni3 = "";
        var auxImporte3 = "";
        var auxQty4 = "";
        var auxProd4 = "";
        var auxUni4 = "";
        var auxConcep4 = "";
        var auxValorUni4 = "";
        var auxImporte4 = "";
        var auxQty5 = "";
        var auxProd5 = "";
        var auxUni5 = "";
        var auxConcep5 = "";
        var auxValorUni5 = "";
        var auxImporte5 = "";
        auxaux = this.fnGetValorComillaSimple(c1, "CANTIDAD");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(c1, "CANTIDAD");
        auxQty1 = auxaux;
        auxaux = this.fnGetValorComillaSimple(c1, "CLAVEPRODSERV");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(c1, "CLAVEPRODSERV");
        auxProd1 = auxaux;        
        auxaux = this.fnGetValorComillaSimple(c1, "CLAVEUNIDAD");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(c1, "CLAVEUNIDAD");
        auxUni1 = auxaux;
        auxaux = this.fnGetValorComillaSimple(c1, "DESCRIPCION");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(c1, "DESCRIPCION");
        auxConcep1 = auxaux;
        auxaux = this.fnGetValorComillaSimple(c1, "VALORUNITARIO");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(c1, "VALORUNITARIO");
        auxValorUni1 = auxaux;        
        auxaux = this.fnGetValorComillaSimple(c1, "IMPORTE");
        if(auxaux.length < 1)
          auxaux = this.fnGetValor(c1, "IMPORTE");
        auxImporte1 = auxaux;

        if(c2.length > 1){
          auxaux = this.fnGetValorComillaSimple(c2, "CANTIDAD");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c2, "CANTIDAD");
          auxQty2 = auxaux;
          auxaux = this.fnGetValorComillaSimple(c2, "CLAVEPRODSERV");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c2, "CLAVEPRODSERV");
          auxProd2 = auxaux;
          auxaux = this.fnGetValorComillaSimple(c2, "CLAVEUNIDAD");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c2, "CLAVEUNIDAD");
          auxUni2 = auxaux;
          auxaux = this.fnGetValorComillaSimple(c2, "DESCRIPCION");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c2, "DESCRIPCION");
          auxConcep2 = auxaux;
          auxaux = this.fnGetValorComillaSimple(c2, "VALORUNITARIO");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c2, "VALORUNITARIO");
          auxValorUni2 = auxaux;        
          auxaux = this.fnGetValorComillaSimple(c2, "IMPORTE");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c2, "IMPORTE");
          auxImporte2 = auxaux;          
        }
        if(c3.length > 1){
          auxaux = this.fnGetValorComillaSimple(c3, "CANTIDAD");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c3, "CANTIDAD");
          auxQty3 = auxaux;
          auxaux = this.fnGetValorComillaSimple(c3, "CLAVEPRODSERV");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c3, "CLAVEPRODSERV");
          auxProd3 = auxaux;
          auxaux = this.fnGetValorComillaSimple(c3, "CLAVEUNIDAD");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c3, "CLAVEUNIDAD");
          auxUni3 = auxaux;
          auxaux = this.fnGetValorComillaSimple(c3, "DESCRIPCION");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c3, "DESCRIPCION");
          auxConcep3 = auxaux;
          auxaux = this.fnGetValorComillaSimple(c3, "VALORUNITARIO");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c3, "VALORUNITARIO");
          auxValorUni3 = auxaux;        
          auxaux = this.fnGetValorComillaSimple(c3, "IMPORTE");
          if(auxaux.length < 1)
            auxaux = this.fnGetValor(c3, "IMPORTE");
          auxImporte3 = auxaux;          
        }
        var arrSpecialStrings = [{'RAZON' : auxGes.razon,    //--> this.infoGes[0].razon,   //--> Trae la info de gestora seleccionada en el sistema
                                  'RFCGES' : factura.rfc,    //--> this.infoSuc[0].rfc,   //--> Trae la info de gestora seleccionada en el sistema
                                  'DOMSUC' : auxGes.domSuc,
                                  'WWWGES' : auxReg,
                                  'FECHACTO': factura.fec + "   " + factura.hr,
                                  'CVE' : factura.serie + " - " + factura.folio,
                                  'ESQ': factura.cert,
                                  'CPCTE' : auxLugarExp,
                                  'FOLIO': auxFolio,
                                  'CTO' : auxCto,
                                  'EFECTO' : auxTipo,
                                  'CTE' : auxCte,
                                  'RFCCTE': factura.rfcRec,
                                  'PTOCTE': auxUso,        
                                  'QTY1' : auxQty1,   
                                  'SATCVE1' : auxProd1,      
                                  'SATUNI1' : auxUni1,      
                                  'SATCONCEP1' : auxConcep1,   
                                  'SATVAL1' :  "$ " + this.dataService.fnFormatMoney(auxValorUni1),   
                                  'SATIMP1' :  "$ " + this.dataService.fnFormatMoney(auxImporte1),  
                                  'QTY2' : auxQty2,   
                                  'SATCVE2' : auxProd2,      
                                  'SATUNI2' : auxUni2,      
                                  'SATCONCEP2' : auxConcep2,   
                                  'SATVAL2' :  auxValorUni2 == "" ? "" : "$ " + this.dataService.fnFormatMoney(auxValorUni2),   
                                  'SATIMP2' :  auxImporte2 == "" ? "" : "$ " + this.dataService.fnFormatMoney(auxImporte2),  
                                  'QTY3' : auxQty3,   
                                  'SATCVE3' : auxProd3,      
                                  'SATUNI3' : auxUni3,      
                                  'SATCONCEP3' : auxConcep3,   
                                  'SATVAL3' :  auxValorUni3 == "" ? "" : "$ " + this.dataService.fnFormatMoney(auxValorUni3),   
                                  'SATIMP3' :  auxImporte3 == "" ? "" : "$ " + this.dataService.fnFormatMoney(auxImporte3),  
                                  'QTY4' : auxQty4,   
                                  'SATCVE4' : auxProd4,      
                                  'SATUNI4' : auxUni4,      
                                  'SATCONCEP4' : auxConcep2,   
                                  'SATVAL4' :  auxValorUni4 == "" ? "" : "$ " + this.dataService.fnFormatMoney(auxValorUni4),   
                                  'SATIMP4' :  auxImporte4 == "" ? "" : "$ " + this.dataService.fnFormatMoney(auxImporte4),  
                                  'QTY5' : auxQty5,   
                                  'SATCVE5' : auxProd5,      
                                  'SATUNI5' : auxUni5,      
                                  'SATCONCEP5' : auxConcep5,   
                                  'SATVAL5' :  auxValorUni5 == "" ? "" : "$ " + this.dataService.fnFormatMoney(auxValorUni5),   
                                  'SATIMP5' :  auxImporte5 == "" ? "" : "$ " + this.dataService.fnFormatMoney(auxImporte5),  
                                  'SUBTOTAL' : "$ " + this.dataService.fnFormatMoney(factura.sub),
                                  'TRASLADOS' : "$ " + this.dataService.fnFormatMoney(auxImpuestosTras),
                                  'RETENCIONES' : "$ " + this.dataService.fnFormatMoney(auxImpuestosRet),
                                  'MONTO': "$ " + this.dataService.fnFormatMoney(factura.tot),
                                  'SATMONEDA' : auxMoneda,
                                  'SATMETODO' : auxMetodoPago,
                                  'SATFORMA' : auxFormaPago,
                                  'SATCADENA' : "||1.1|" + auxFolio + "|" + auxFechaTimbre + "|" + auxRFCPAC + "|" + auxSelloSAT + "|" + auxCertSAT + "||",
                                  'SELLOCFDI' : factura.sello,
                                  'SELLOSAT' : auxSelloSAT,
                                  'RFCPAC' : auxRFCPAC,
                                  'FECHACER' : auxFechaTimbre,
                                  'CERTPAC' : auxCertSAT
                                }];
        var auxTxtMargen = [0,0,0,0];
        for(var i = 0; i < this.elemImpFactura.length; i++){
          if(this.elemImpFactura[i].tipo == "content"){
              if(this.elemImpFactura[i].margin.indexOf(",") > 0)
                auxTxtMargen = this.elemImpFactura[i].margin.split(",");
                auxTxtMargen = auxTxtMargen.map(function (x) { 
                  return parseInt(x.toString(), 10); 
                }); 
              //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
              text.push({
                          text: this.dataService.fnReplaceSpecialStrings(this.elemImpFactura[i].dato, arrSpecialStrings),
                          style: this.elemImpFactura[i].style,
                          margin: [0,0,0,0],
                          color: this.elemImpFactura[i].color,
                          alignment: this.elemImpFactura[i].alignment
                        });                  
          }
          if(this.elemImpFactura[i].tipo == 'image' && this.elemImpFactura[i].dato == "ƒLOGO" ){
              //console.log(this.auxLogoFact);
              images.push({
                          image:  this.dataService.fnGetBase64Image(this.auxLogoFact, this.auxLogoFact.naturalWidth, this.auxLogoFact.naturalHeight),
                          fit: [110, 79],
                          alignment: this.elemImpFactura[i].alignment,
                          absolutePosition: {x: parseInt(this.elemImpFactura[i].margin.split(",")[0]), y: parseInt(this.elemImpFactura[i].margin.split(",")[1]) }
                        })
                
          }          
          if(this.elemImpFactura[i].tipo == 'image' && this.elemImpFactura[i].dato != "ƒLOGO" ){
            images.push({
                        image:  auxImgQR.src,
                        fit: [130, 130],
                        alignment: this.elemImpFactura[i].alignment,
                        absolutePosition: {x: parseInt(this.elemImpFactura[i].margin.split(",")[0]), y: parseInt(this.elemImpFactura[i].margin.split(",")[1]) }
                      })
          }          
          if(this.elemImpFactura[i].tipo == 'line'){
              canvas.push({
                          type: 'line',
                          r: 0,
                          x1: parseInt(this.elemImpFactura[i].margin.split(",")[0]),
                          y1: parseInt(this.elemImpFactura[i].margin.split(",")[1]),
                          x2: parseInt(this.elemImpFactura[i].margin.split(",")[2]),
                          y2: parseInt(this.elemImpFactura[i].margin.split(",")[3]),
                          lineColor: this.elemImpFactura[i].color,
                          lineWidth: this.elemImpFactura[i].alignment                               
                        })
          }
          if(this.elemImpFactura[i].tipo == 'rect'){
            canvas.push({
                        type: 'rect',
                        r: 5,
                        fillOpacity: 0.3,
                        color: this.elemImpFactura[i].style,
                        x: parseInt(this.elemImpFactura[i].margin.split(",")[0]),
                        y: parseInt(this.elemImpFactura[i].margin.split(",")[1]),
                        w: parseInt(this.elemImpFactura[i].margin.split(",")[2]),
                        h: parseInt(this.elemImpFactura[i].margin.split(",")[3]),
                        lineColor: this.elemImpFactura[i].color,
                        lineWidth: this.elemImpFactura[i].alignment                               
                      })
          }      
          if(this.elemImpFactura[i].tipo == 'ellipse'){
            canvas.push({
                        type: 'ellipse',
                        fillOpacity: 1,
                        color: 'transparent',
                        x: parseInt(this.elemImpFactura[i].margin.split(",")[0]),
                        y: parseInt(this.elemImpFactura[i].margin.split(",")[1]),
                        r1: parseInt(this.elemImpFactura[i].margin.split(",")[2]),
                        r2: parseInt(this.elemImpFactura[i].margin.split(",")[3]),
                        lineColor: this.elemImpFactura[i].color,
                        lineWidth: this.elemImpFactura[i].alignment                               
                      })
          }      

          if(this.elemImpFactura[i].tipo == 'column'){
            columns.push({
                        width:this.elemImpFactura[i].margin, 
                        text: this.dataService.fnReplaceSpecialStrings(this.elemImpFactura[i].dato, arrSpecialStrings), 
                        style: this.elemImpFactura[i].style,
                        color: this.elemImpFactura[i].color,
                        border: [true, true, true, true],
                        alignment: this.elemImpFactura[i].alignment                               
                      })
          }      
          if(this.elemImpFactura[i].tipo == "new_line"){
            text.push({
                          columns
                    })
            columns = [];
          }
          if(this.elemImpFactura[i].tipo == "new_row"){
            text.push({
                          table
                    })
            table = [];
          }
          if(this.elemImpFactura[i].tipo == "position"){
            text2.push({
                        text: this.dataService.fnReplaceSpecialStrings(this.elemImpFactura[i].dato, arrSpecialStrings),
                        style: this.elemImpFactura[i].style,
                        color: this.elemImpFactura[i].color,
                        alignment: this.elemImpFactura[i].alignment,                              
                        absolutePosition: {x: parseInt(this.elemImpFactura[i].margin.split(",")[0]), y: parseInt(this.elemImpFactura[i].margin.split(",")[1])}
                      });                  
          }
        }
        styles = this.elemFacturaStyle;

        var stack = [];

        if (this.formatoFactura[index].tipo == "TABLA")
          stack[0] = text;
        else
          stack.push({text:text});
        stack[1] = text2;
        stack.push({canvas:canvas});
        //console.log(stack);

        var dd = {
          pageSize: this.formatoFactura[index].pageSize,
          pageOrientation: this.formatoFactura[index].pageOrientation,
          pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
          content: [
            {
              lineHeight: height,
              alignment: 'justify',
              background: 'white',
              color: 'black',
              stack
            }
            ,images        
          ],
          styles
        }
        //console.log(dd);
        if(this.dataService.navegador["name"] == "CHROME" || this.dataService.navegador["name"] == "FIREFOX")
          pdfMake.createPdf(dd).open();
        else
          pdfMake.createPdf(dd).download("nombre_archivo" + ".pdf");    
      }, 50);                 
    }, 10);
  }

  fnGetValorConceptoAmpersand(numConcep, txt, nodo){
    var auxPosIni = -1;
    var auxPosFin = -1;
    var auxTxt = "";
    if(numConcep == 1)
      auxPosIni = this.posIniConceptos;  //--> De otra forma buscar la posicion inicial del numero de concepto
    else{
      auxPosIni = txt.toUpperCase().indexOf('/CFDI:CONCEPTO') + 14;
      if(numConcep >= 3)
        auxPosIni = txt.substr(auxPosIni).toUpperCase().indexOf('/CFDI:CONCEPTO') + 14
      if(numConcep >= 4)
        auxPosIni = txt.substr(auxPosIni).toUpperCase().indexOf('/CFDI:CONCEPTO') + 14
      if(numConcep >= 5)
        auxPosIni = txt.substr(auxPosIni).toUpperCase().indexOf('/CFDI:CONCEPTO') + 14
      if(numConcep >= 6)
        auxPosIni = txt.substr(auxPosIni).toUpperCase().indexOf('/CFDI:CONCEPTO') + 14
      if(numConcep >= 7)
        auxPosIni = txt.substr(auxPosIni).toUpperCase().indexOf('/CFDI:CONCEPTO') + 14
      if(numConcep >= 8)
        auxPosIni = txt.substr(auxPosIni).toUpperCase().indexOf('/CFDI:CONCEPTO') + 14
    }
    auxTxt = txt.substr(auxPosIni);
    //console.log(auxTxt)
    auxPosIni = auxTxt.toUpperCase().indexOf(nodo.toUpperCase());
    if(auxPosIni < 0)
      return "";
    auxTxt = auxTxt.substr(auxPosIni + nodo.length + 1); //--> Largo del concepto + 2 caracteres (=)
    //console.log(auxTxt)
    auxPosFin = auxTxt.indexOf("&");
    if(nodo == "CFDI:TRASLADOS")
      auxPosFin = auxTxt.toUpperCase().indexOf('/CFDI:TRASLADOS');
    if(nodo == "CFDI:RETENCIONES")
      auxPosFin = auxTxt.toUpperCase().indexOf('/CFDI:RETENCIONES');
    auxTxt = auxTxt.substr(0, auxPosFin);
    //console.log(auxTxt)
    return auxTxt;
  }

  fnGetValor(txt, nodo){
    var auxPosIni = -1;
    var auxPosFin = -1;
    var auxTxt = "";
    //console.log(nodo.toUpperCase())
    auxPosIni = txt.toUpperCase().indexOf(nodo.toUpperCase());
    //console.log(auxPosIni)
    if(auxPosIni < 0)
      return "";
    auxTxt = txt.substr(auxPosIni + nodo.length + 2); //--> Largo del concepto + 2 caracteres (=")
    //console.log(auxTxt)
    auxPosFin = auxTxt.indexOf('"'); 
    //if(auxTxt.indexOf('"/') < auxTxt.indexOf('" '))
    //  auxPosFin = auxTxt.indexOf('"/');
    auxTxt = auxTxt.substr(0, auxPosFin);
    return auxTxt;
  }

  fnGetValorComillaSimple(txt, nodo){
    var auxPosIni = -1;
    var auxPosFin = -1;
    var auxTxt = "";
    //console.log(nodo.toUpperCase())
    auxPosIni = txt.toUpperCase().indexOf(nodo.toUpperCase());
    if(auxPosIni < 0)
      return "";
    auxTxt = txt.substr(auxPosIni + nodo.length + 2); //--> Largo del concepto + 2 caracteres (=")
    //console.log(auxTxt)
    auxPosFin = auxTxt.indexOf("'"); 
    //console.log(auxTxt.indexOf("'/"));
    if(auxTxt.indexOf("'/") < auxTxt.indexOf("' ") && auxTxt.indexOf("'/") > 0){
      //console.log("AQUI!")
      auxPosFin = auxTxt.indexOf("'/");
      //console.log(auxPosFin);
    }
    auxTxt = auxTxt.substr(0, auxPosFin);
    //console.log(auxTxt);
    return auxTxt;
  }

  fnImprimir(idFormato){       
    this.dataService.getElemFormatoImp(idFormato, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW'", 1).subscribe(
                        rows => {   
                                this.elemImp = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnElementosImpresionCargados(idFormato));              
  }

  fnElementosImpresionCargados(idFormato){
    var index = this.formato.findIndex(x => x.id ===idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    //console.log(this.elemImp) 
    var text = [];
    var text2 = [];
    var columns = [];
    var canvas = [];
    var table = [];
    var styles = this.elemStyle;
    var auxCtasHor = "";
    var auxProducto = "";
    var idCta="";
    var auxCtaGes = [];
    

    var auxFecOri = "1900-01-01";
    if(this.general[0].ctoOri){
      console.log("ES REESTRUCTURA DE: " + this.general[0].ctoOri)
      this.esReestruct = true;
      this.fueReestructura = false;
      //this.ctoReestruct = this.general.ctoOri;
      //this.montoReestruct = this.general.montoOri;     
    }
    if(this.fueReestructura){
      auxFecOri = this.general[0].fecCto;
    }
    else{
      //console.log("ELSE");
      //console.log(this.item.fecOri);
      if(this.general.fecOri != null)
        auxFecOri = this.general[0].fecOri;
      else
        auxFecOri = this.general[0].fecCto;
    }
    var auxHI = this.general[0].HI;
    var auxHG = this.general[0].HG;
    if(this.general[0].idPeriodicidad == 5){   //--> Esquema 2
    //  console.log("ESQ 2")
    }
    else{           //--> Esquema 1
      //console.log("ESQ 1")
      auxHI = auxHI + auxHG;
      auxHG = 0;
    }
console.log("AQUI!");
console.log(this.general[0]);
    var arrSpecialStrings = [{
                              'CTO' : this.general[0].cto,
                              'CTE' : this.general[0].cte,
                              'CVE' : this.general[0].cveAct,
                              'MONTO': this.dataService.fnFormatMoney(this.general[0].monto),
                              'HI': this.dataService.fnFormatMoney(auxHI),
                              'HG': this.dataService.fnFormatMoney(auxHG),
                              'DOMCTE' : this.general[0].domcte,
                              'COLCTE' : this.general[0].loc,
                              'CPCTE' : this.general[0].cp,
                              'EDOCTE' : this.general[0].edo,
                              'MUNCTE' : this.general[0].mun,
                              'ESQ': this.general[0].esquema,
                              'FECHACTO': this.dataService.fnGetDateFormat(this.general[0].fecCto2, "Y-M-D"),
                              'FECHALARGACTO': this.dataService.fnGetDateFormat(this.general[0].fecCto2, "DMMY"),
                              'TITULO' : this.general[0].idPeriodicidad == 5 ? "Monto financiado" : "Pago de Servicio",
                              //'NOTA' : this.item.idPeriodicidad == 5 ? "(hasta 3 meses)" : (this.item.idPeriodicidad <= 3 ? "(" + this.item.totPagos + " pagos)" : "(PAGADO)"),
                              'NOTA' : this.general[0].idPeriodicidad == 5 ? this.dataService.fnGetDateFormat(this.general[0].fecPP, "Y-M-D") : (this.general[0].idPeriodicidad <= 3 ? "(" + this.general[0].totPagos + " pagos)" : "(PAGADO)"),
                            }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
          if(this.elemImp[i].margin.indexOf(",") > 0)
            auxTxtMargen = this.elemImp[i].margin.split(",");
            auxTxtMargen = auxTxtMargen.map(function (x) { 
              return parseInt(x.toString(), 10); 
            }); 
          //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
          text.push({
                      text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                      style: this.elemImp[i].style,
                      margin: [0,0,0,0],
                      color: this.elemImp[i].color,
                      alignment: this.elemImp[i].alignment
                    });                  
      }
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }      
      if(this.elemImp[i].tipo == 'ellipse'){
        canvas.push({
                    type: 'ellipse',
                    fillOpacity: 1,
                    color: 'transparent',
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    r1: parseInt(this.elemImp[i].margin.split(",")[2]),
                    r2: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }      

      if(this.elemImp[i].tipo == 'column'){
        columns.push({
                    width:this.elemImp[i].margin, 
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings), 
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    border: [true, true, true, true],
                    alignment: this.elemImp[i].alignment                               
                  })
      }      
      if(this.elemImp[i].tipo == "new_line"){
        text.push({
                      columns
                })
        columns = [];
      }
      if(this.elemImp[i].tipo == "new_row"){
        text.push({
                      table
                })
        table = [];
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
    }
    styles = this.elemStyle;

    var stack = [];

    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    //console.log(stack);

    var dd = {
      pageSize: this.formato[index].pageSize,
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: height,
          alignment: 'justify',
          background: 'white',
          color: 'black',
          stack
        }
      ],
      styles
    }
    //console.log(dd);
    if(this.dataService.navegador["name"] == "CHROME" || this.dataService.navegador["name"] == "FIREFOX")
      pdfMake.createPdf(dd).open();
    else
      pdfMake.createPdf(dd).download("nombre_archivo" + ".pdf");
  }

}
